module.exports = __webpack_public_path__ + "media/images/iconTicket-9d5eefb3eac5d86e22d93aead185e22e.png";